import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { dealLabelsState } from '../state/DealboardDataState';
import { useLabelActions } from './useLabelActions';

export const useLabelCreation = () => {
  const labelsState = useAtomValue(dealLabelsState);
  const { handleCreateLabel } = useLabelActions();

  const processLabels = useCallback(
    async (labels: string[] | null) => {
      if (!labels) {
        return labels;
      }

      const filteredLabels = labels.filter((l) => l !== null);

      const currentLabels = labelsState.state === 'hasData' ? labelsState.data : [];
      const existingLabels = new Set(currentLabels.map((label) => label.name));
      const newLabels = filteredLabels.filter((label) => !existingLabels.has(label));

      for (const newLabel of newLabels) {
        await handleCreateLabel(newLabel);
      }

      return filteredLabels;
    },
    [labelsState, handleCreateLabel]
  );

  return { processLabels };
};
